import React from "react";
import { Link } from "react-router-dom";

const Banner: React.FC = () => {
  const list: {
    name: string;
    link: string;
  }[] = [
    {
      name: "Terms of Service",
      link: "/policies/terms-of-service",
    },
    {
      name: "Privacy Policy",
      link: "/policies/privacy-policy",
    },
    {
      name: "Cancellation Policy",
      link: "/policies/cancellation-policy",
    },
    {
      name: "Community Guidelines",
      link: "/policies/community-guidelines",
    },
    {
      name: "Additional Policies",
      link: "/policies/additional-policies",
    },
    {
      name: "Deluxe and Super Deluxe Class",
      link: "/policies/vehicle-categorization",
    },
    {
      name: "Driver Eligibility",
      link: "/policies/driver-eligibility",
    },
    {
      name: "Security Deposits",
      link: "/policies/security-deposits",
    },
  ];
  return (
    <div className="w-full flex flex-col p-10 gap-4 lg:gap-7 justify-center items-center bg-midGreen">
      <p className="font-Poppins text-[50px] lg:text-[70px] text-center font-black text-white leading-[70px]">
        Ecomoto Policies
      </p>
      <ol className="w-[85%] lg:w-[70%] flex justify-center  flex-row gap-4 lg:gap-8 list-none flex-wrap ">
        {list.map((item, index) => (
          <Link to={item.link} key={index}>
            <li className="text-white text-[14px] lg:text-[18px] cursor-pointer hover:underline">
              {item.name}
            </li>
          </Link>
        ))}
      </ol>
    </div>
  );
};

export default Banner;
